import userSlice from './slice';
export * from './actions';

export const {} = userSlice.actions;

export default userSlice.reducer;
